import { createContext, useContext, useState } from 'react';

const ChatContext = createContext({ open: false, setOpen: () => {}, toggle: () => {} });

export const ChatProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  return <ChatContext.Provider value={{ open, setOpen, toggle: () => setOpen((o) => !o) }}>{children}</ChatContext.Provider>;
};

export const useChat = () => useContext(ChatContext);
